<template>
  <div v-if="loaded" class="text-center bodyContainer">
    <div class="mt-5 pt-2 mb-4 check-mark">
      <img data-cy="checkIcon" src="@/assets/check-circle-green.svg" alt="green checkmark icon" />
    </div>
    <h2 class="my-0">{{ $t('message.credit.thankYouHeader') }}</h2>
    <p class="mt-3 mx-auto px-0 px-sm-5">{{ thankyouParagraph }}</p>
    <MobialisButton
      v-if="!hideAllCloseBtns"
      class="mt-4"
      data-cy="closeBtn"
      @click="clickBtn()"
      v-av-analytics-cta-interaction="{ elementText: $t('message.common.returnToVehicle'), eventActionResult: 'exit' }"
      >{{ $t('message.common.returnToVehicle') }}
    </MobialisButton>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { modalMethods } from '@/mixins';
import leadService from '@/services/leadService';
import { privateStoreInstance } from '@/store';
import helperFunctions from '@/utils/helperFunctions';

export default {
  components: {},
  mixins: [modalMethods],
  beforeRouteLeave: helperFunctions.ignoreRoutes(['employer-form', 'mortgage-form']),
  data() {
    return {
      loaded: false,
      thankyouParagraph: `${this.$t('message.credit.thankYouParagraph[0]')} ${
        this.$store.state.business.info.name
      } ${this.$t('message.credit.thankYouParagraph[1]')}`,
    };
  },
  computed: {
    ...mapGetters('business', ['getBusinessCountry', 'getThisIsAmerica']),
    ...mapGetters('lead', ['getLeadId']),
    ssnInfoCollected() {
      return privateStoreInstance.state.socialSecurityNumber;
    },
    ssnIsEnabled() {
      return this.$store.state.business.info.creditSettings.enableSSNCapture;
    },
    submitSSN() {
      return this.ssnIsEnabled && this.ssnInfoCollected !== '';
    },
  },
  async mounted() {
    try {
      this.$store.commit('SET_DHS_STATE', ['credit', 'complete']);
      this.$store.commit('credit/SET_PRE_QUALIFICATION_LOAN_APPLIED');
      // if we have completed the finance flow with a different VOI we
      // now need to indicate that this vehicle should be used in update lead
      if (this.$store.state.credit.CIMFinanceApplicationVehicle) {
        this.$store.commit('credit/SET_STATE', ['applyCIMFinanceApplicationVehicle', true]);
      }
      if (this.submitSSN) {
        try {
          await leadService.sendSocialSecurityNumber(this.getLeadId, this.ssnInfoCollected);
        } catch (err) {
          this.$log('Error submitting ssn info', err);
        }
      }
      this.logCIMApplyForFinancingComplete();
      // We only need to update the lead if we need to set the selected prequal loan
      // or if the CIMFinanceApplicationVehicle is set
      if (
        (this.$store.state.credit.selectedPreQualificationLoans &&
          this.$store.state.credit.selectedPreQualificationLoans.length > 0) ||
        this.$store.state.credit.CIMFinanceApplicationVehicle
      ) {
        await this.$store.dispatch('lead/updateLead');
      }
      await this.$store.dispatch('lead/createFinanceApplication');
      await this.$store.dispatch('lead/updateMetadata');
      await this.$store.dispatch('lead/completeLead');
    } catch (err) {
      this.$log('Error in completing finance application', err);
      this.$router.push({ name: `credit-in-error-${this.baseRoute}` });
    } finally {
      this.loaded = true;
      this.$store.commit('SET_LOADING', false);
    }
  },
  methods: {
    async clickBtn() {
      await this.closeModal().catch(error =>
        this.$log('Error completing lead after receiving close message from SDK.', error)
      );
    },
    logCIMApplyForFinancingComplete() {
      if (this.$store.state.credit.CIMFinanceApplicationVehicle !== null) {
        let isVoi = false;

        if (
          this.$store.state.credit.matchedInventoryResults.vehicleOfInterest &&
          this.$store.state.credit.matchedInventoryResults.vehicleOfInterest.id ===
            this.$store.state.credit.CIMFinanceApplicationVehicle.id
        ) {
          isVoi = true;
        }

        const payload = {
          elementInteractedWith: 'cim.applyForFinancingComplete',
          vehicleId: this.$store.state.credit.CIMFinanceApplicationVehicle.id,
          isInitialVoiEvent: isVoi,
        };
        this.$store.dispatch('metrics/logModalInteraction', payload).catch(error => {
          this.$log('Error in logging interaction', error);
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.check-mark {
  img {
    width: 60px;
    height: 60px;
    @media (min-width: 576px) {
      width: 80px;
      height: 80px;
    }
  }
}
h2 {
  font-size: 22px;
  font-weight: bold;
  @media (min-width: 576px) {
    font-size: 28px;
  }
}
.bodyContainer {
  margin-top: 48px;

  @media (min-width: 576px) {
    margin-top: 28px;
  }
}

@media (min-width: 576px) {
  .btn {
    width: auto !important;
  }
}
</style>
